import Personalization from './Personalization';

export default Personalization;
